<div class="modal">
        <div class="modal-header">
            <h2>{{ (registrationMode ? 'REGISTERMODAL_TITLE' : 'LOGINFORM_TITLE') | translate }}</h2>
            <button type="button" class="btn close-btn" (click)="confirmModalRef.show()">
                <fa-icon [icon]="['fal', 'times']" size="2x"></fa-icon>
            </button>
        </div>
        <div class="modal-body">
            <div class="panel panel-login d-flex flex-column">
                <div class="panel-heading mb-4">
                    <div class="row">
                        <div class="col-12">
                            <a
                                role="button"
                                class="text-uppercase tab-item"
                                [class.active]="registrationMode"
                                id="register-form-link"
                                (click)="toggleRegistrationMode(true)">
                                {{ 'REGISTERFORM_TITLE' | translate }}
                            </a>
                            <a
                                role="button"
                                class="text-uppercase tab-item"
                                [class.active]="!registrationMode"
                                id="login-form-link"
                                (click)="toggleRegistrationMode()">
                                {{ 'LOGINFORM_TITLE' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    @if (registrationMode) {
                    <form
                        name="registerForm"
                        id="register-form"
                        (ngSubmit)="register(registerForm)"
                        role="form"
                        #registerForm="ngForm">
                        <div class="mb-3 required">
                            <label class="form-label" for="email">
                                {{ 'REGISTERFORM_EMAIL' | translate }}
                            </label>
                            <input
                                ngModel
                                type="email"
                                name="email"
                                id="email"
                                tabindex="0"
                                class="form-control form-control-border"
                                required
                                shdValidateInput
                                shdValidateEmail />
                        </div>
                        <div class="mb-3 required">
                            <label class="form-label" for="regionId">
                                {{ 'SHARED_REGION' | translate }}
                            </label>
                            <select
                                [ngModel]="selectedRegion"
                                name="regionId"
                                id="regionId"
                                class="form-control form-control-border"
                                required>
                                @for (region of regionList; track region) {
                                <option [ngValue]="region.id">
                                    {{ region.displayName | translate }}
                                </option>
                                }
                            </select>
                        </div>
                        <div class="mb-3 required">
                            <label class="form-label" for="password">
                                {{ 'REGISTERFORM_PASSWORD' | translate }}
                            </label>
                            <div class="position-relative">
                                <input
                                    ngModel
                                    type="password"
                                    shdToggle
                                    name="password"
                                    id="password"
                                    tabindex="0"
                                    class="form-control form-control-border"
                                    [pattern]="passwordPattern"
                                    required
                                    shdValidateEqual="confirmPassword"
                                    reverse="true"
                                    shdValidateInput
                                    [customErrorMsg]="'REGISTERFORM_PASSWORDPATTERN_ERROR' | translate" />
                            </div>
                        </div>
                        <div class="mb-3 required">
                            <label class="form-label" for="confirmPassword">
                                {{ 'REGISTERFORM_PASSWORDCONFIRM' | translate }}
                            </label>
                            <div class="position-relative">
                                <input
                                    ngModel
                                    type="password"
                                    shdToggle
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    tabindex="0"
                                    class="form-control form-control-border"
                                    shdValidateEqual="password"
                                    required
                                    shdValidateInput
                                    [customErrorMsg]="'REGISTERFORM_PASSWORDCONFIRM_ERROR' | translate" />
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    [ngModel]="false"
                                    name="isContactable"
                                    id="isContactable"
                                    class="form-check-input" />
                                <label class="form-check-label text-muted" for="isContactable">
                                    {{ 'REGISTERFORM_ALLOWCONTACT' | translate }}
                                </label>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="form-check required">
                                <input
                                    type="checkbox"
                                    id="acceptTos"
                                    ngModel
                                    name="acceptTos"
                                    class="form-check-input"
                                    required />
                                <label class="form-check-label text-muted tos" for="acceptTos">
                                    <span [innerHTML]="tosAcceptText | safeHTML"></span>
                                    *
                                </label>
                            </div>
                        </div>
                        <shd-recaptcha [(valid)]="reCaptchaValid"></shd-recaptcha>
                        <small class="form-text text-muted">
                            {{ 'SHARED_REQUIRED_FIELD_INFO' | translate }}
                        </small>
                        <div class="my-3">
                            <button
                                type="submit"
                                name="register-submit"
                                id="register-submit"
                                tabindex="0"
                                class="btn btn-success"
                                [disabled]="registerBtnLoading || registerForm.invalid || !reCaptchaValid">
                                @if (registerBtnLoading) {
                                <fa-icon [icon]="['fal', 'spinner']" [rotate]="true"></fa-icon>
                                }
                                {{ 'REGISTERFORM_BTN_REGISTER' | translate }}
                            </button>
                        </div>
                    </form>
                    } @else {
                    <form name="loginForm" id="login-form" (ngSubmit)="login(loginForm)" role="form" #loginForm="ngForm">
                        <div class="mb-3">
                            <label class="form-label" for="username">
                                {{ 'LOGINFORM_EMAIL' | translate }}
                            </label>
                            <input
                                ngModel
                                email
                                type="email"
                                name="username"
                                id="username"
                                tabindex="0"
                                class="form-control form-control-border"
                                required
                                shdValidateInput
                                [customErrorMsg]="'REGISTERFORM_EMAIL_ERROR' | translate" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label" for="password">
                                {{ 'LOGINFORM_PASSWORD' | translate }}
                            </label>
                            <div class="position-relative">
                                <input
                                    ngModel
                                    type="password"
                                    shdToggle
                                    name="password"
                                    id="password"
                                    tabindex="0"
                                    class="form-control"
                                    required
                                    shdValidateInput />
                            </div>
                        </div>
                        <div class="mb-3">
                            <button
                                class="btn btn-success"
                                [disabled]="loginForm.dirty && loginForm.invalid"
                                type="submit"
                                name="login-submit"
                                id="login-submit"
                                tabindex="0">
                                {{ 'LOGINFORM_BTN_LOGIN' | translate }}
                            </button>
                        </div>
                    </form>
                    }
                </div>
            </div>
            @if (!showCodeEntry) { @if (registrationMode) {
            <div class="card card-no-shadow border-0 card-register-advantages bg-blue">
                <div class="card-body">
                    <h3 class="mb-3">{{ 'LANDING_ADVANTAGES' | translate }}</h3>
                    @for (advantage of advantages; track advantage) {
                    <div class="d-flex align-items-baseline">
                        <span class="advantage-circle me-2">
                            <fa-icon [icon]="['fal', 'check']"></fa-icon>
                        </span>
                        <label>{{ advantage | translate }}</label>
                    </div>
                    }
                </div>
            </div>
            } } @else {
            <p>{{ 'REGISTERMODAL_CONFIRMATION_DESCRIPTION' | translate }}</p>
            <form #confirmationCodeForm="ngForm" (ngSubmit)="confirmAccount(confirmationCodeForm)">
                <div class="mb-3">
                    <label class="form-label" for="confirmationCode">
                        {{ 'REGISTERFORM_CONFIRMATIONCODE' | translate }}
                    </label>
                    <input ngModel type="text" name="confirmationCode" id="confirmationCode" tabindex="0" class="form-control" />
                </div>
                <div class="mb-3">
                    <button
                        type="submit"
                        name="confirmationCode-submit"
                        id="confirmationCode-submit"
                        tabindex="0"
                        class="btn btn-success"
                        [disabled]="confirmBtnLoading">
                        @if (confirmBtnLoading) {
                        <fa-icon [icon]="['fal', 'spinner']" [animation]="'spin'"></fa-icon>
                        }
                        {{ 'REGISTERFORM_BTN_USECONFIRMATIONCODE' | translate }}
                    </button>
                </div>
            </form>
            }
        </div>
</div>

<shd-confirm-modal
    #confirmModalRef
    (confirmed)="activeModal.dismiss()"
    [question]="'MAIN_REGISTERMODAL_SURETOCLOSEQUESTION' | translate"></shd-confirm-modal>
